import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["questionTypeCheckbox", "answerCheckbox", "answerRadio"]

  connect() {
    // Initialize the correct state on page load
    if (this.hasQuestionTypeCheckboxTarget) {
      this.toggleQuestionType()
    }
  }

  toggleQuestionType() {
    const isMultipleAnswer = this.questionTypeCheckboxTarget.checked

    // Toggle visibility of checkboxes and radio buttons in answer fields
    this.answerCheckboxTargets.forEach(checkbox => {
      if (isMultipleAnswer) {
        checkbox.classList.remove("d-none")
      } else {
        checkbox.classList.add("d-none")
      }
    })

    this.answerRadioTargets.forEach(radio => {
      if (isMultipleAnswer) {
        radio.classList.add("d-none")
      } else {
        radio.classList.remove("d-none")
      }
    })

    // When switching to single answer mode (radio buttons), ensure only one is checked
    if (!isMultipleAnswer) {
      let firstChecked = false
      this.answerCheckboxTargets.forEach((checkbox, index) => {
        const correspondingRadio = this.answerRadioTargets[index]
        if (correspondingRadio) {
          if (checkbox.checked && !firstChecked) {
            // Keep the first checked answer as the selected radio button
            correspondingRadio.checked = true
            firstChecked = true
          } else {
            // Uncheck all other radio buttons
            correspondingRadio.checked = false
          }
        }
      })
    }
  }

  updateHeroCategory(event) {
    const selectElement = event.target
    const categoryName = selectElement.value
    const courseCategory = selectElement.closest('.course-category')
    const colour = courseCategory.dataset.color

    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

    fetch('/admin/courses/update_hero_category', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        category_name: categoryName,
        colour: colour
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        console.log('Hero category updated successfully')
        this.showToast('Hero category updated successfully!', 'success')
      } else {
        console.error('Failed to update hero category:', data.errors)
        this.showToast('Failed to update hero category', 'danger')
      }
    })
    .catch(error => {
      console.error('Error updating hero category:', error)
      this.showToast('An error occurred while updating', 'danger')
    })
  }

  showToast(message, type = 'success') {
    // Create toast container if it doesn't exist
    let toastContainer = document.querySelector('.position-fixed.top-0.end-0.p-3')
    if (!toastContainer) {
      toastContainer = document.createElement('div')
      toastContainer.className = 'position-fixed top-0 end-0 p-3'
      toastContainer.style.zIndex = '11'
      document.body.appendChild(toastContainer)
    }

    // Create toast element matching flash_messages structure
    const toastId = 'toast-' + Date.now()
    const headerClass = type === 'success' ? 'bg-success' : 'bg-danger'
    const toastHtml = `
      <div id="${toastId}" class="toast" role="alert" aria-live="assertive" aria-atomic="true">
        <div class="toast-header text-white ${headerClass}">
          <strong class="me-auto">Lifeblood Q&A</strong>
          <button class="btn-close btn-close-white" type="button" data-bs-dismiss="toast" aria-label="Close"></button>
        </div>
        <div class="toast-body">
          ${message}
        </div>
      </div>
    `
    
    toastContainer.insertAdjacentHTML('beforeend', toastHtml)
    
    // Initialize and show the toast
    const toastElement = document.getElementById(toastId)
    const toast = new bootstrap.Toast(toastElement, {
      autohide: true,
      delay: 3000
    })
    toast.show()

    // Remove toast element after it's hidden
    toastElement.addEventListener('hidden.bs.toast', () => {
      toastElement.remove()
    })
  }
}